// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"styles__menuItem___2zLjr","menuIcon":"styles__menuIcon___f_Luk","menuText":"styles__menuText___1N7Er"};